// removed by extract-text-webpack-plugin
module.exports = {"acknowledgeButton":"_1IS-IL1-PovSHunzqPI0B3","errorRow":"_2s6otcyAB5ksZ_VnWOC-ko","ignoreWarningsCLI":"_2kTu0I5i-bto-WWtp8wMDw","eventsHeadline":"_1WtaLm63_Kunzyp38wyEqZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NewEventsTable/NewEventsTable.less
// module id = 35
// module chunks = 0